import { SemanticBackgroundColorToken } from '@televet/kibble-ui/build/theme/tokens';
import { PimsWritebackStatus } from 'shared/types/graphql';
import { AuxiliaryPimsWritebackStatus } from '../constants';
import { IWritebackStatus } from '../utils';

export const WritebackStatusColor: Record<IWritebackStatus, SemanticBackgroundColorToken> = {
  [PimsWritebackStatus.Pending]: 'background.warning',
  [PimsWritebackStatus.PendingRetryAutomatic]: 'background.warning',
  [PimsWritebackStatus.PendingRetryManual]: 'background.warning',
  [PimsWritebackStatus.Success]: 'background.success',
  [PimsWritebackStatus.Failure]: 'background.danger',
  [AuxiliaryPimsWritebackStatus.Invalid]: 'background.danger',
  [AuxiliaryPimsWritebackStatus.Disabled]: 'background.info',
};

export const WritebackStatusDescription: Record<
  IWritebackStatus,
  ({ hasAdminRoleAtCurrentClinic, pimsName }: { hasAdminRoleAtCurrentClinic: boolean; pimsName: string }) => string
> = {
  [PimsWritebackStatus.Pending]: () => 'A writeback is in progress.',
  [PimsWritebackStatus.PendingRetryAutomatic]: () =>
    'You may need to refresh this page to see if the retry was successful.',
  [PimsWritebackStatus.PendingRetryManual]: () =>
    'You may need to refresh this page to see if the retry was successful.',
  [PimsWritebackStatus.Success]: () => '',
  [PimsWritebackStatus.Failure]: ({ pimsName }) => `This writeback needs to be manually posted in ${pimsName}.`,
  [AuxiliaryPimsWritebackStatus.Invalid]: ({ hasAdminRoleAtCurrentClinic }) =>
    hasAdminRoleAtCurrentClinic
      ? 'Please fix an invalid configuration in the Payments Settings page to retry this writeback.'
      : 'Please contact an admin to fix an invalid configuration in the Payments Settings before retrying this writeback.',
  [AuxiliaryPimsWritebackStatus.Disabled]: () => 'A writeback was not attempted for this payment.',
};
